import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=1aa699f8&scoped=true"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=1aa699f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa699f8",
  null
  
)

export default component.exports